import React from "react";
import FacebookIcon from '@material-ui/icons/Facebook';
import "../../Style/BotonCompartir.css";

const Facebook = ({d}) => {
  return (
    <a className="Result-Information__Facebook" href={`https://www.facebook.com/sharer/sharer.php?u=${d}%2F&layout=button_count&size=large&appId=113078520873&width=114&height=28`} allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"><FacebookIcon /></a>
  );
};
export default Facebook;